import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const Layout = () => {
  const [activeModal, setActiveModal] = useState(null);

  return (
    <>
      {/* Pass modal state and setter to Header */}
      <Header activeModal={activeModal} setActiveModal={setActiveModal} />

      <main id="main-content" tabIndex={-1}>
        {/* Pass setActiveModal to Outlet children via context */}
        <Outlet context={{ setActiveModal }} />
      </main>

      <Footer />
    </>
  );
};

export default Layout;
